/*
 * Redux Middleware for handling API calls
 * On successful api response, the response and responseObj are attached to the action and passed to next middleware
 * On Error and error object is attached to the action and API_ERROR action is dispatched
 * Injection of config into the middleware to use it for authentication
 * config can be passed as a parameter to the middleware in applyMiddleware method when creating the store
 *
 */

//import BookmarkWorker from '../webworkers/bookmark.worker.js';
import _ from 'lodash';
import {openDB, deleteDB, wrap, unwrap} from 'idb';
import MainWorker from '../webworkers/main.worker.js';
import env from '../util/env';
import qs from 'query-string';
import {documentGetAllParamNames} from '../util/uiconstants.js';

const tasklistUpdate = (config) => (store) => (next) => (action) => {
	if (action.type != 'SET_TASK_BOOKMARK') {
		return next(action);
	}

	if (action.type === 'GET_DOCS_FOR_BOOKMARKED_TASK') {
		return next(action);
	}

	const ONLINE_DB = 'ONLINE_DB',
		OFFLINE_DB = 'OFFLINE_DB';

	const dbPromise = openDB('canvas-idb', 1, {
		upgrade(db) {
			db.createObjectStore(ONLINE_DB);
			db.createObjectStore(OFFLINE_DB);
		}
	});

	const idbKeyval = {
		async get(key) {
			return (await dbPromise).get(ONLINE_DB, key);
		},
		async set(key, val) {
			return (await dbPromise).put(ONLINE_DB, val, key);
		},
		async setOffline(key, val) {
			return (await dbPromise).put(OFFLINE_DB, val, key);
		},
		async delete(key) {
			return (await dbPromise).delete(ONLINE_DB, key);
		},
		async clear() {
			return (await dbPromise).clear(ONLINE_DB);
		},
		async keys() {
			return (await dbPromise).getAllKeys(ONLINE_DB);
		}
	};

	if (!config) {
		const configMsg = `
		Config unavailable.
		The AD package requires config to get the authorization token for the api call.`;
		console.log(configMsg);
	}

	let data = action.meta.api.data;
	if (data && data.length && !data[0].value) {
		return next(action);
	}

	if (action.meta.worker) {
		let _len = action.meta.tasks.length;
		let urlToRetrieve = action.meta.url + 'tasks/?categoryId=2&subCategoryId=1';
		let tasklistUrl = action.meta.url + 'tasks/?categoryId=2';
		let tasklistItems = [];
		let documentUrls = [];
		let offlineEvidences = [];

		//idbKeyval.keys().then((onlineKeys) => {
		for (var i = 0; i < _len; i++) {
			let taskId = action.meta.tasks[i].taskId;
			let taskDetails = _.find(action.response, {
				url: action.meta.url + 'Tasks/' + taskId
			});

			let taskObj = {
				id: taskDetails.response.taskId,
				name: taskDetails.response.taskName,
				taskDisplayName: taskDetails.response.taskDisplayName,
				statusId: taskDetails.response.taskStatusId,
				taskDueDate: (taskDetails.response.timephase && taskDetails.response.timephase.dueDate) || '',
				typeId: taskDetails.response.taskTypeId,
				isEPSignoffRequired: taskDetails.response.isEPSignoffRequired,
				isEQRSignoffRequired: taskDetails.response.isEQRSignoffRequired,
				isEPSignoffUserRequired: taskDetails.response.isEPSignoffUserRequired,
				isEQRSignoffUserRequired: taskDetails.response.isEQRSignoffUserRequired
			};

			tasklistItems.push(taskObj);
			let docListUrl = action.response
				.map((x) => x.url)
				.filter((x) => {
					let onlineKeyParams = x.indexOf('/documents?') > -1 ? qs.parse(x.split('?')[1]?.toLowerCase()) : [];
					return (
						onlineKeyParams[documentGetAllParamNames.filteredEntityType.toLowerCase()] === 'task' &&
						onlineKeyParams[documentGetAllParamNames.documentCategoryName.toLowerCase()] === 'evidence' &&
						onlineKeyParams[documentGetAllParamNames.filteredEntityIdGuid.toLowerCase()] === taskId
					);
				})[0];

			let taskDocuments = _.find(action.response, {
				url: docListUrl
			});

			let taskDocumentsResponse = taskDocuments && taskDocuments.response;

			if (taskDocumentsResponse && taskDocumentsResponse.data && taskDocumentsResponse.data.length > 0) {
				let urls = _.map(taskDocumentsResponse.data, function(docItem) {
					return `${
						env.getDocHelperConfig().docHelperApiUri
					}Document?docUrl=${env.getDocServiceUrl()}&engagementId=${docItem.engagementId}&resourceUri=${env.getURL('Engg_AuthAudience_URL')}&fileId=${docItem.id}&docTypeId=${docItem.documentTypeId}&openDocument=false&readonly=false`;
				});
				offlineEvidences = offlineEvidences.length
					? [...offlineEvidences, ...taskDocumentsResponse.data]
					: [...taskDocumentsResponse.data];
				documentUrls.push(...urls);
			}
		}

		store.dispatch({
			type: 'GET_DOCS_FOR_BOOKMARKED_TASK',
			meta: {
				worker: MainWorker,
				workerParams: {
					url: documentUrls,
					token: action.meta.auth.token
				}
			}
		});
		//});
		var tasklistCountUpdate = (count) => {
			idbKeyval
				.get(tasklistUrl)
				.then((tasklistData) => {
					tasklistData.categories[0].subCategories[0].count = count;
					idbKeyval.set(tasklistUrl, tasklistData);
				})
				.catch((er) => {
					console.info('[GET]: offline -Tasklist  in indexedDB call', er);
					action.error = er;
					action.response = {};
					return next({type: 'API_ERRORS', er});
				});
		};

		idbKeyval
			.get(urlToRetrieve)
			.then((taskData) => {
				if (action.type == 'SET_TASK_BOOKMARK' && action.meta.type != 'OFFLINE_PREP') {
					tasklistItems = tasklistItems.concat(taskData.taskGroups[0].tasks);
				}

				// sort order
				taskData.taskGroups[0].tasks = tasklistItems.sort((a, b) => {
					if (a.name < b.name) {
						return -1;
					}
					if (a.name > b.name) {
						return 1;
					}
					return 0;
				});
				taskData.totalCount = tasklistItems.length;
				taskData.availablePages = 1;
				idbKeyval.set(urlToRetrieve, taskData);

				let task_document_relate = {
					documents: offlineEvidences.reduce(function(item, e1) {
						var matches = item.filter(function(e2) {
							return e1.id == e2.id;
						});
						if (matches.length == 0) {
							item.push(e1);
						}
						return item;
					}, [])
				};

				let engagementIdFragment =
					action.meta.api.url.toLowerCase().indexOf('/engagements/') > -1
						? action.meta.api.url.toLowerCase().split('/engagements/')[1]
						: action.meta.api.url.toLowerCase().split('engagementid=')[1];
				let engagementId = engagementIdFragment.split('/')[0].split('&')[0];

				idbKeyval.set(engagementId + '_' + 'offlineEvidences', task_document_relate);
				next({
					type: 'SET_OFFLINE_PREP',
					isCompleted: true
				});
				//tasklistCountUpdate(taskItemsIDB.length);
			})
			.catch((er) => {
				console.info('[GET]: offline - Error in indexedDB call', er);
				action.error = er;
				action.response = {};
				return next({type: 'API_ERRORS', er});
			});
	}

	return next(action);
};

export default tasklistUpdate;
